import(/* webpackMode: "eager" */ "/vercel/path0/ui/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/ui/components/Analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/vercel/path0/ui/components/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QueryProvider"] */ "/vercel/path0/ui/components/providers/QueryProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/vercel/path0/ui/components/providers/SessionProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VoiceProvider"] */ "/vercel/path0/ui/components/providers/VoiceProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteHeader"] */ "/vercel/path0/ui/components/SiteHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/ui/components/ThemeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VoiceFloatingControls"] */ "/vercel/path0/ui/components/voice/VoiceFloatingControls.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/ui/components/WebVitals.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/ui/node_modules/.pnpm/next@14.2.35_@babel+core@7.28.5_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/ui/node_modules/.pnpm/next@14.2.35_@babel+core@7.28.5_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
